import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { HttpService } from './http.service';

@NgModule({
  imports: [CommonModule, HttpClientModule],
  declarations: [],
})
export class HttpModule {
  static forRoot(): ModuleWithProviders<HttpModule> {
    return {
      ngModule: HttpModule,
      providers: [HttpService],
    };
  }
}
